












import { defineComponent, PropType } from "@vue/composition-api";
import { TranslateResult } from "vue-i18n";
import BaseInputFileWithPreview from "@/components/BaseInputFileWithPreview";
import BaseThumbnailButton from "@/components/BaseThumbnailButton";

export default defineComponent({
  name: "MediaFileAddButton",
  components: { BaseInputFileWithPreview, BaseThumbnailButton },
  props: {
    accept: { type: Array as () => string[] },
    multiple: { type: Boolean, default: false },
    mobileHideText: { type: Boolean, default: false },
    title: { type: String as PropType<TranslateResult> },
  },
});
